import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Authorize from './Login';

// StrictMode removed to prevent double rendering and form submission issues
ReactDOM.render(
  <Authorize />,
  document.getElementById('root')
);

